export default {
  readers: [
    'CashflowReaders',
    'Admin'
  ],
  collaborators: [
    'CashflowWriter',
    'Admin'
  ]
}
